import React, { createContext, useContext, type PropsWithChildren } from "react"
import type { Client } from "../api/client"

const APIClientContext = createContext<Client | undefined>(undefined)

export function APIClientProvider({
  client,
  children,
}: APIClientProviderProps) {
  return (
    <APIClientContext.Provider value={client}>
      {children}
    </APIClientContext.Provider>
  )
}

type APIClientProviderProps = PropsWithChildren<{
  client: Client
}>

export function useAPIClient() {
  const context = useContext(APIClientContext)

  if (!context)
    throw new Error(
      "`useAPIClient` must be used in a component wrapped in a `APIClientProvider`",
    )

  return context
}
